import { createDiaClient, createSyncEngine, setAccessToken, type DiaClient } from '@dia/db';
import { SUPABASE_ANON_KEY, SUPABASE_URL } from './env';

export const supabase: DiaClient = createDiaClient({
  url: SUPABASE_URL,
  anonKey: SUPABASE_ANON_KEY,
  storageKey: 'dia.ops.auth',
});

export const sync = createSyncEngine(supabase);

export function applySessionToken(token: string | null): void {
  setAccessToken(supabase, token);
}

/**
 * Forgets the service worker's copies of REST reads (cache "supabase-reads").
 *
 * Those copies are keyed by address and not by who asked, so a list the crew
 * were shown yesterday would be handed to the owner today whenever the network
 * is slow. Called whenever somebody signs in or out.
 */
export function forgetCachedReads(): void {
  try {
    void globalThis.caches?.delete('supabase-reads');
  } catch {
    // No Cache API here. Nothing was cached.
  }
}
